// ===== COMPONENTE: CONTAINER DE MENSAGENS =====

import React, { useEffect, useRef } from "react";
import { Loader2, Bot } from "lucide-react";
import type { Message } from "../types";
import { MessageBubble } from "./MessageBubble";

interface ChatContainerProps {
  messages: Message[];
  loading: boolean;
}

export const ChatContainer: React.FC<ChatContainerProps> = ({
  messages,
  loading,
}) => {
  const messagesEndRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages, loading]);

  return (
    <div
      className="flex-1 overflow-y-auto p-4 sm:p-6 space-y-4"
      style={{ backgroundColor: "var(--bg-primary)" }}
    >
      {messages.map((msg) => (
        <MessageBubble key={msg.id} message={msg} />
      ))}

      {loading && (
        <div className="flex gap-3">
          <div
            className="w-10 h-10 rounded-full flex items-center justify-center"
            style={{ backgroundColor: "var(--primary-color)" }}
          >
            <Bot className="w-5 h-5 text-white" />
          </div>
          <div
            className="rounded-2xl rounded-tl-none px-4 py-3 shadow-md border"
            style={{
              backgroundColor: "var(--card-bg)",
              borderColor: "var(--border-color)",
            }}
          >
            <div className="flex items-center gap-2">
              <Loader2
                className="w-4 h-4 animate-spin"
                style={{ color: "var(--primary-color)" }}
              />
              <span
                className="text-sm"
                style={{ color: "var(--text-tertiary)" }}
              >
                Analisando dados...
              </span>
            </div>
          </div>
        </div>
      )}

      <div ref={messagesEndRef} />
    </div>
  );
};
